<div class="row">
  <div class="col-xs-12 col-12">
    <pagination [totalItems]="66" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)"></pagination>
  </div>
</div>

<pre class="card card-block card-header mb-3">
  Page changed to: {{page}}
</pre>
